import { createAction, createThunkAction, handleActions, combineReducers } from "platopulse/lib/redux";

import { canEditPermissions } from "platopulse/lib/groups";
import PlatopulseAnalytics from "platopulse/lib/analytics";
import { t } from 'c-3po';
import { PermissionsApi, CollectionsApi } from "platopulse/services";

const RESET = "platopulse/admin/permissions/RESET";
export const reset = createAction(RESET);

const INITIALIZE = "platopulse/admin/permissions/INITIALIZE";
export const initialize = createThunkAction(INITIALIZE, (load, save) =>
    async (dispatch, getState) => {
        dispatch(reset({ load, save }));
        await Promise.all([
            dispatch(loadPermissions()),
            dispatch(loadGroups()),
        ]);
    }
);

// TODO: move these to their respective ducks
const LOAD_COLLECTIONS = "platopulse/admin/permissions/LOAD_COLLECTIONS";
export const loadCollections = createAction(LOAD_COLLECTIONS, () => CollectionsApi.list());


const LOAD_GROUPS = "platopulse/admin/permissions/LOAD_GROUPS";
export const loadGroups = createAction(LOAD_GROUPS, () => PermissionsApi.groups());

const LOAD_PERMISSIONS = "platopulse/admin/permissions/LOAD_PERMISSIONS";
export const loadPermissions = createThunkAction(LOAD_PERMISSIONS, () =>
    async (dispatch, getState) => {
        const { load } = getState().admin.permissions;
        return load();
    }
);

const UPDATE_PERMISSION = "platopulse/admin/permissions/UPDATE_PERMISSION";
export const updatePermission = createThunkAction(UPDATE_PERMISSION, ({ groupId, entityId, value, updater, postAction }) =>
    async (dispatch, getState) => {
        if (postAction) {
            let action = postAction(groupId, entityId, value);
            if (action) {
                dispatch(action);
            }
        }
        return updater(groupId, entityId, value);
    }
);

const SAVE_PERMISSIONS = "platopulse/admin/permissions/SAVE_PERMISSIONS";
export const savePermissions = createThunkAction(SAVE_PERMISSIONS, () =>
    async (dispatch, getState) => {
        PlatopulseAnalytics.trackEvent("Permissions", "save");
        const { permissions, revision, save } = getState().admin.permissions;
        let result = await save({
            revision: revision,
            groups: permissions
        });
        return result;
    }
)

const save = handleActions({
    [RESET]: { next: (state, { payload }) => payload.save }
}, null);
const load = handleActions({
    [RESET]: { next: (state, { payload }) => payload.load }
}, null);

const permissions = handleActions({
    [RESET]: { next: () => null },
    [LOAD_PERMISSIONS]: { next: (state, { payload }) => payload.groups },
    [SAVE_PERMISSIONS]: { next: (state, { payload }) => payload.groups },
    [UPDATE_PERMISSION]: { next: (state, { payload }) => payload }
}, null);

const originalPermissions = handleActions({
    [RESET]: { next: () => null },
    [LOAD_PERMISSIONS]: { next: (state, { payload }) => payload.groups },
    [SAVE_PERMISSIONS]: { next: (state, { payload }) => payload.groups },
}, null);

const revision = handleActions({
    [RESET]: { next: () => null },
    [LOAD_PERMISSIONS]: { next: (state, { payload }) => payload.revision },
    [SAVE_PERMISSIONS]: { next: (state, { payload }) => payload.revision },
}, null);

const groups = handleActions({
    [LOAD_GROUPS]: { next: (state, { payload }) =>
        payload && payload.map(group => ({
            ...group,
            editable: canEditPermissions(group)
        }))
    },
}, null);

const collections = handleActions({
    [LOAD_COLLECTIONS]: { next: (state, { payload }) => payload },
}, null);

const saveError = handleActions({
    [RESET]: { next: () => null },
    [SAVE_PERMISSIONS]: {
        next: (state) => null,
        throw: (state, { payload }) => (payload && typeof payload.data === "string" ? payload.data : payload.data.message) || t`Sorry, an error occurred.`
    },
    [LOAD_PERMISSIONS]: {
        next: (state) => null,
    }
}, null);

export default combineReducers({
    save,
    load,

    permissions,
    originalPermissions,
    saveError,
    revision,
    groups,

    collections
});



// WEBPACK FOOTER //
// ./admin/permissions/permissions.js